/*
 *
 * Date: 2025
 * Description: Main context Hook.
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { useState , useCallback , useMemo } from "react";
import { NavigateFunction } from "react-router-dom";

//Interfaces
import { i_main_context } from "../interfaces/context.interface";
import { i_user } from "../interfaces/user.interface";

//Constants
import { default_user } from "../utils/constant";


const MainHook = (): i_main_context => {
	const [authenticated, setAuthenticated] = useState<boolean>(false);
	const [user, setUser] = useState<i_user>(default_user);
	const [ redirect_url, setRedirectUrl ] = useState<string>('')
	const setCurrentAuth = useCallback((currentAuth: boolean): void => {
		setAuthenticated(currentAuth);
	}, []);
	const setCurrentUser = useCallback((currentUser: i_user): void => {
		setUser(currentUser);
	}, []);

	const HandleLogout = useCallback( (Navigator: NavigateFunction) => {
			setCurrentAuth(false);
			setCurrentUser(default_user);
			if (Navigator !== undefined) Navigator("/login");
		},
		[setCurrentAuth, setCurrentUser]
	);

	const HandleLogin = useCallback( (user: i_user) => {
			setCurrentAuth(true);
			setCurrentUser({ ...default_user, ...user });
		},
		[setCurrentAuth, setCurrentUser]
	);
	const setCurrentRedirectUrl = useCallback(( current_redirect_url: string): void => { 
		    setRedirectUrl(current_redirect_url);
        }, [setRedirectUrl]
	)
	return useMemo(
		() => ({ authenticated, setCurrentAuth, user, redirect_url, setCurrentRedirectUrl, setCurrentUser, HandleLogin, HandleLogout, }),
		[ authenticated, setCurrentAuth, user, redirect_url, setCurrentRedirectUrl, setCurrentUser, HandleLogin, HandleLogout, ]
	);
};

export default MainHook;